import axios from "axios";

export const ADD_DEVICE_TYPE_REQUEST = "ADD_DEVICE_TYPE_REQUEST";
export const ADD_DEVICE_TYPE_SUCCESS = "ADD_DEVICE_TYPE_SUCCESS";
export const ADD_DEVICE_TYPE_FAILURE = "ADD_DEVICE_TYPE_FAILURE";

export const GET_DEVICE_TYPE_REQUEST = "GET_DEVICE_TYPE_REQUEST";
export const GET_DEVICE_TYPE_SUCCESS = "GET_DEVICE_TYPE_SUCCESS";
export const GET_DEVICE_TYPE_FAILURE = "GET_DEVICE_TYPE_FAILURE";

export const DELETE_DEVICE_TYPE_REQUEST = "DELETE_DEVICE_TYPE_REQUEST";
export const DELETE_DEVICE_TYPE_SUCCESS = "DELETE_DEVICE_TYPE_SUCCESS";
export const DELETE_DEVICE_TYPE_FAIL = "DELETE_DEVICE_TYPE_FAIL";

export const UPDATE_DEVICE_TYPE_REQUEST = "UPDATE_DEVICE_TYPE_REQUEST";
export const UPDATE_DEVICE_TYPE_SUCCESS = "UPDATE_DEVICE_TYPE_SUCCESS";
export const UPDATE_DEVICE_TYPE_FAIL = "UPDATE_DEVICE_TYPE_FAIL";

export const allDeviceType = () => async (dispatch) => {
  let token = JSON.parse(localStorage.getItem("token"));
  dispatch({ type: GET_DEVICE_TYPE_REQUEST });
  try{
    const url = `${process.env.REACT_APP_API_URL}/deviceType/all`
    const response = await axios({
        method: "GET",
        url: url,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
    });
    if (response.status === 200) {
      dispatch({
        type: GET_DEVICE_TYPE_SUCCESS,
        payload: response.data || [],
      })
    }
  } catch (error) {
    dispatch({
      type: GET_DEVICE_TYPE_FAILURE,
      payload: error.message,
    })
  }
}
export const addDeviceType = (formData) => async (dispatch) => {
    let token = JSON.parse(localStorage.getItem("token"));
     dispatch({ type: ADD_DEVICE_TYPE_REQUEST });

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/deviceType/addType`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    dispatch({
      type: ADD_DEVICE_TYPE_SUCCESS,
      payload: response.data,
    });
    dispatch(allDeviceType())
    return response.data;
  } catch (error) {
    dispatch({
      type: ADD_DEVICE_TYPE_FAILURE,
      payload: error.response?.data || "Something went wrong",
    });

    throw error;
  }
};

export const deleteDeviceType = (id) => {
  return async (dispatch) => {
    let token = JSON.parse(localStorage.getItem("token"));
    dispatch({ type: DELETE_DEVICE_TYPE_REQUEST });

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/deviceType/${id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "*/*",
          },
        }
      );

      if (!res.ok) {
        throw new Error(`Error: ${res.status}`);
      }
      dispatch({
        type: DELETE_DEVICE_TYPE_SUCCESS,
        payload: id,
      });
      dispatch(allDeviceType())
    } catch (error) {
      dispatch({
        type: DELETE_DEVICE_TYPE_FAIL,
        payload: error.message,
      });
    }
  };
};

export const updateDeviceType = (id, formData) => async (dispatch, getState) => {

  try {
    dispatch({ type: UPDATE_DEVICE_TYPE_REQUEST });
    let token = JSON.parse(localStorage.getItem("token"));

    const response = await axios.put(
      `${process.env.REACT_APP_API_URL}/deviceType/${id}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "*/*",
        },
      }
    );

    dispatch({
      type: UPDATE_DEVICE_TYPE_SUCCESS,
      payload: response.data,
    });
    dispatch(allDeviceType())
    return response.data;
  } catch (error) {
    dispatch({
      type: UPDATE_DEVICE_TYPE_FAIL,
      payload: error.response?.data?.message || error.message,
    });

    throw error;
  }
};